import React from "react"; // eslint-disable-line no-unused-vars
import ReactDOM from "react-dom";
import App from "./components/app";
import { Provider } from "./store/provider";

if (process.env.NODE_ENV === "development") {
  console.log("TB-BROWSE: Loading");
}

let render = function (app, theme) {
  ReactDOM.render(
    <React.Fragment>
      <Provider>
        <App theme={theme} />
      </Provider>
    </React.Fragment>,
    app
  );
};

let loadApp = function () {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-BROWSE: Initializing React component");
  }
  let app = document.getElementById("tbbrowse");
  if (app) {
    fetch(process.env.THEME_URL)
      .then((response) => response.json())
      .then((theme) => {
        render(app, theme);
      })
      .catch((error) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TB-BROWSE: ", error);
        }
        render(app, {});
      });
  } else {
    if (process.env.NODE_ENV === "development") {
      console.log("TB-BROWSE: No element to insert component into");
    }
  }
};
if (document.readyState === "loading") {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-BROWSE: Waiting for document ready state");
  }
  document.addEventListener("DOMContentLoaded", loadApp);
} else {
  loadApp();
}
